import { isEmpty } from '@widergy/web-utils/lib/array';

export const formatedAccount = (clientNumber, accountsList) => {
  const isAnOldAccount =
    !isEmpty(accountsList) && accountsList.find(_account => _account.client_number === clientNumber);

  if (isAnOldAccount) return clientNumber;
  return parseInt(clientNumber, 10) + 1;
};
